import { ENDPOINT } from "../../network/ENDPOINT";
import { callApiToServer } from '../callApi';

function resolveToken(authToken) {
  return authToken || localStorage.getItem("token") || localStorage.getItem("admin_token") || "";
}

export async function getDailyCardAuditAPI(authToken, { date, forceRecompute = false } = {}) {
  try {
    const token = resolveToken(authToken);
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + token,
    };
    const body = JSON.stringify({ date, forceRecompute });
    return await callApiToServer(body, header, "POST", ENDPOINT.daily_card_audit);
  } catch (err) {
    throw err;
  }
}

export async function recomputeDailyAuditAPI(authToken, { date } = {}) {
  try {
    const token = resolveToken(authToken);
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + token,
    };
    const body = JSON.stringify({ date });
    return await callApiToServer(body, header, "POST", ENDPOINT.daily_card_audit_recompute);
  } catch (err) {
    throw err;
  }
}

export async function updateAnomalyStatusAPI(authToken, anomalyId, payload) {
  try {
    const token = resolveToken(authToken);
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + token,
    };
    const body = JSON.stringify(payload);
    const endUrl = `${ENDPOINT.daily_card_audit_anomaly}/${anomalyId}`;
    return await callApiToServer(body, header, "POST", endUrl);
  } catch (err) {
    throw err;
  }
}

export async function getItemizedSoldCardsAPI(authToken, payload) {
  try {
    const token = resolveToken(authToken);
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + token,
    };
    const body = JSON.stringify(payload);
    return await callApiToServer(body, header, "POST", ENDPOINT.daily_card_audit_cards);
  } catch (err) {
    throw err;
  }
}
